module.exports = __webpack_public_path__ + "img/liberty-resort-white.6aa188b9.png";